export default
{
    description : 'Veuillez sélectionner un lieu ci-dessous.' ,
    disagree    : 'Fermer' ,
    empty       : 'Aucun lieu disponible.' ,
    fail        : 'Impossible de charger les lieux, veuillez relancer un peu plus tard.',
    loading     : 'Chargement en cours...' ,
    search      : 'Rechercher un lieu ...' ,
    title       : 'Sélectionner un lieu'
};
